import React from "react";

const AmountRender = ({ row }) => {
  return (
    <>
      {row.payments.map((pay, index) => (
        <p key={index} style={{ borderBottom: "1px solid #F7F9FB" }}>
          {pay.amount?.toLocaleString()}
        </p>
      ))}
    </>
  );
};

export default AmountRender;
